module.exports = __webpack_public_path__ + "static/media/bg.trainings-page.e51d5315.jpg";